import { useState, PropsWithChildren } from "react";
import { DialogResponsive } from "@/components/common/dialogs";

import { Procedure } from "@/types";
import { FormCreateProcedure } from "./form-create-procedure";
import { FormUpdateProcedure } from "./form-update-procedure";

type FormProcedureProps = PropsWithChildren & {
  procedure?: Procedure;
};

export function FormProcedure({ children, procedure }: FormProcedureProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={procedure ? "Atualizar procedimento" : "Novo procedimento"}
      description={
        procedure
          ? "Preencha os campos para atualizar o procedimento."
          : "Preencha os campos para criar um novo procedimento."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
      className="h-auto"
    >
      {procedure ? (
        <FormUpdateProcedure
          procedure={procedure}
          handleClose={() => setOpen(false)}
        />
      ) : (
        <FormCreateProcedure handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
